import { createEffect } from '@databases/selections';

import { manuallyFireExposureEvent } from '@canvas/client-feature-flags/experiments';

import { type SelectionEffectFeature, SelectionFeatureKeys } from '../../features/types';

/**
 * Registers the one-shot experiment exposure effect. It fires on the first
 * selection replacement for each recyclable machine instance and resets its
 * local deduplication flag on disposal.
 */
export function createEnrollmentExposureEffectFeature(): SelectionEffectFeature {
  return {
    key: SelectionFeatureKeys.EXPERIMENT_EXPOSURE_EFFECT,
    type: 'effect',
    factory: createEffect(() => {
      let exposed = false;

      return {
        dispose() {
          exposed = false;
        },

        deltaTypes: ['selectionModified', 'selectionReplaced'],

        onDelta() {
          if (!exposed) {
            manuallyFireExposureEvent('databasesSelectionsPerformance');

            exposed = true;
          }
        },
      };
    }),
  };
}
